<!--
 * @Description: 安装位置变更申请弹框
 * @Author: ChenXueLin
 * @Date: 2021-11-22 14:33:52
 * @LastEditTime: 2022-07-01 09:23:47
 * @LastEditors: ChenXueLin
-->
<template>
  <el-dialog
    v-dialogDrag
    title="安装位置变更申请"
    :visible.sync="locationChangeVisible"
    width="80%"
    :before-close="handleClose"
    :close-on-click-modal="false"
    v-loading="loading"
    :element-loading-background="loadingBackground"
    custom-class="report-dialog"
    @open="open"
  >
    <div class="dialog-content">
      <div>
        <div class="title"><span class="line"></span>变更说明</div>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请填写变更说明。提交后，运营会收到变更申请，运营调整后，工单会同步更新。如运营未及时调整，请及时电话沟通..."
          v-model="applyRemark"
          v-if="applyStatus == 'init' && itemId"
        >
        </el-input>
        <el-form v-if="applyStatus != 'init' && itemId" :inline="true">
          <el-row>
            <el-col :span="24">
              <el-form-item label="变更说明:"
                >{{ formData.applyRemark }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请人:"
                >{{ formData.applyUserName }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="申请时间:"
                >{{ formData.applyTime }}
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div>
        <div class="title"><span class="line"></span>变更位置</div>
        <el-form v-if="applyStatus != 'init' && itemId" :inline="true">
          <el-row>
            <el-col :span="24">
              <el-form-item label="运营反馈结果:"
                >{{ formData.auditRemark }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="确认人:"
                >{{ formData.auditUser }}
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="确认时间:">{{
                formData.auditTime
              }}</el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="details"
          highlight-current-row
          ref="selectTable"
          min-height="200px"
        >
          <el-table-column
            prop="productName"
            label="产品名称"
            min-width="200"
            align="center"
            header-align="center"
          >
          </el-table-column>

          <el-table-column
            prop="productCode"
            label="产品型号"
            min-width="220"
            align="center"
            header-align="center"
          >
          </el-table-column>

          <el-table-column
            prop="originalPositionName"
            label="下单位置"
            align="center"
            min-width="140"
            header-align="center"
          >
          </el-table-column>
          <el-table-column
            prop="applyPositionCode"
            :label="applyStatus == 'init' ? '修改后位置' : '申请修改位置'"
            align="center"
            min-width="200"
            header-align="center"
          >
            <template slot-scope="{ row }">
              <e6-vr-select
                v-model="row.applyPositionCode"
                :data="row.selectableInstallPositions"
                placeholder="修改后位置"
                title=""
                is-title
                :props="{
                  id: 'installPositionCode',
                  label: 'installPositionName',
                }"
                clearable
                v-if="applyStatus == 'init'"
              ></e6-vr-select>
              <span v-else>{{ row.applyPositionName }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-if="applyStatus != 'init'"
            prop="changePositionName"
            label=" 运营确认位置"
            align="center"
            min-width="140"
            header-align="center"
          >
          </el-table-column>
        </el-table>
      </div>
      <div>
        <div class="title"><span class="line"></span>安装位置示例图</div>
        <div class="img-demo">
          <div
            v-for="(item, index) in previewSrcList"
            :key="index"
            @click="openViewer(index, previewSrcList)"
          >
            <el-image :src="item" :fit="'contain'"></el-image>
          </div>
          <!-- <el-image
            :src="previewSrcList[0]"
            :preview-src-list="previewSrcList"
            :fit="'contain'"
          ></el-image>
          <el-image
            :src="previewSrcList[1]"
            :preview-src-list="previewSrcList"
            :fit="'contain'"
          ></el-image> -->
        </div>
      </div>
    </div>

    <div class="dialog-footer" slot="footer">
      <el-button class="cancel" @click="handleClose">取消</el-button>
      <el-button
        type="primary"
        @click="handleConfirm"
        v-if="applyStatus == 'init'"
        >确定</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import { printError } from "@/utils/util";
import {
  getPositionChange,
  savePositionChange,
  batchGetPositionChange,
  batchSavePositionChange,
} from "@/api";

export default {
  name: "locationChangeDialog",
  components: {},
  data() {
    return {
      previewSrcList: [
        "https://e3-oss.obs.cn-east-3.myhuaweicloud.com:443/E3/UploadFiles/synergyTask/2026-01/76f5b310-ef93-11f0-b8d0-81ce668fec96.20260108-170352.jpeg?AccessKeyId=K5PVYY4V8CWRDIZOTXWR&Expires=2398927707&Signature=EoVmb%2FPsCqfsegD5YjJuJAHA8TM%3D",
        "https://e3-oss.obs.cn-east-3.myhuaweicloud.com:443/E3/UploadFiles/synergyTask/2026-01/e3c85280-ef94-11f0-b8d0-81ce668fec96.20260108-164220%20%281%29.jpeg?AccessKeyId=K5PVYY4V8CWRDIZOTXWR&Expires=2398928319&Signature=CwHD5CaWKr4fu%2BwRx69CfC5KZVU%3D",
        "https://e3-oss.obs.cn-east-3.myhuaweicloud.com:443/E3/UploadFiles/synergyTask/2026-01/7e1e22b0-f12a-11f0-a022-8b076d10cd00.20260113-110636.jpg?AccessKeyId=K5PVYY4V8CWRDIZOTXWR&Expires=2399102524&Signature=F8ppgSwTBGuD%2FxwXxasgXN3ctoY%3D"

      ],
      loading: false,
      loadingBackground: "rgba(255,255,255,0.5)", // loading 遮罩颜色
      details: [],
      applyRemark: "",
      formData: {},
      applyStatus: "init", //状态init-未提交,submit-未确认,audited-已确认
    };
  },
  props: {
    locationChangeVisible: { type: Boolean, default: false },
    itemIdList: { type: Array, default: () => [] },
    itemId: { type: Number, default: 19156 },
  },
  mixins: [],
  computed: {},
  watch: {
    // locationChangeVisible: {
    //   immediate: true,
    //   handler(val) {
    //     if (val) {
    //       // this.getPositionChange();
    //     }
    //   },
    // },
  },
  mounted() {
    //
  },

  methods: {
    openViewer(initialIndex, imgList) {
      // 动态导入 Viewer.js
      import("viewerjs").then((Viewer) => {
        import("viewerjs/dist/viewer.css");

        const ViewerConstructor = Viewer.default || Viewer;

        // 创建包含所有图片的容器
        const container = document.createElement("div");
        imgList.forEach((img) => {
          const imgElement = document.createElement("img");
          imgElement.src = img;
          // 剔除链接结尾为undefined的图片
          if (
            imgElement.src &&
            imgElement.src !== "undefined" &&
            !imgElement.src.endsWith("undefined")
          ) {
            container.appendChild(imgElement);
          }
        });

        // 创建 Viewer 实例
        const viewer = new ViewerConstructor(container, {
          inline: false,
          zIndex: 999999, // Viewer 容器的 z-index
          zIndexInline: 999999, // 内联模式的 z-index
          viewed() {
            // 预览查看回调
          },
          toolbar: true,
        });

        // 显示指定索引的图片
        viewer.view(initialIndex);
      });
    },
    open() {
      //  this.getPositionChange();
      if (this.itemIdList.length) {
        this.batchGetPositionChange();
      } else {
        this.getPositionChange();
      }
    },
    //查询单个详情
    async getPositionChange() {
      try {
        this.loading = true;
        let res = await getPositionChange({
          itemId: this.itemId,
        });
        if (res.code == "OK") {
          this.applyRemark = res.data.applyRemark;
          this.applyStatus = res.data.applyStatus;
          this.formData = res.data;
          let details = res.data.details;
          for (let i = 0; i < details.length; i++) {
            details[i].selectableInstallPositions = details[i]
              .selectableInstallPositions.length
              ? details[i].selectableInstallPositions
              : [
                  {
                    installPositionCode: details[i].originalPositionCode,
                    installPositionName: details[i].originalPositionName,
                  },
                ];
            details[i].applyPositionCode = details[i].applyPositionCode
              ? details[i].applyPositionCode
              : "";
            // if (res.data.applyStatus == "init") {
            //   details[i].applyPositionName = details[i].applyPositionName
            //     ? details[i].applyPositionName
            //     : details[i].originalPositionName;
            //   details[i].applyPositionCode = details[i].applyPositionCode
            //     ? details[i].applyPositionCode
            //     : details[i].originalPositionCode;
            // }
          }
          this.details = details;
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //保存单个详情
    async savePositionChange(details) {
      try {
        this.loading = true;
        let res = await savePositionChange({
          applyRemark: this.applyRemark,
          details,
        });
        if (res.code == "OK") {
          this.handleClose();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //查询批量详情
    async batchGetPositionChange() {
      try {
        this.loading = true;
        let res = await batchGetPositionChange({
          itemIdList: this.itemIdList,
        });
        if (res.code == "OK") {
          let details = res.data.details;
          for (let i = 0; i < details.length; i++) {
            details[i].selectableInstallPositions = details[i]
              .selectableInstallPositions.length
              ? details[i].selectableInstallPositions
              : [
                  {
                    installPositionCode: details[i].originalPositionCode,
                    installPositionName: details[i].originalPositionName,
                  },
                ];
            details[i].applyPositionCode = details[i].applyPositionCode
              ? details[i].applyPositionCode
              : "";
            // if (res.data.applyStatus == "init") {
            // details[i].applyPositionName = details[i].originalPositionName;
            // details[i].applyPositionCode = details[i].originalPositionCode;
            // }
          }
          console.log(details);
          this.details = details;
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //批量保存
    async batchSavePositionChange(details) {
      try {
        this.loading = true;
        let res = await batchSavePositionChange({
          applyRemark: this.applyRemark,
          details,
          itemIdList: this.itemIdList,
        });
        if (res.code == "OK") {
          this.handleClose();
        }
      } catch (error) {
        printError(error);
      } finally {
        this.loading = false;
      }
    },
    //关闭弹框
    handleClose() {
      this.$emit("closeDialog", "locationChangeVisible");
    },
    //点击确定
    handleConfirm() {
      if (!this.applyRemark) {
        this.$message.warning("请输入变更说明");
        return false;
      }
      if (
        !this.details.some(
          (v) =>
            v.applyPositionCode ||
            v.applyPositionCode === 0 ||
            v.applyPositionCode === "0"
        )
      ) {
        this.$message.warning("至少需要选择一个安装位置变更");
        return false;
      }
      if (this.itemIdList.length) {
        const details = this.details.map((item) => ({
          productCode: item.productCode,
          originalPositionCode: item.originalPositionCode,
          originalPositionName: item.originalPositionName,
          applyPositionCode: item.applyPositionCode,
          applyPositionName: item.selectableInstallPositions.find(
            (ele) => ele.installPositionCode == item.applyPositionCode
          )?.installPositionName,
        }));
        this.batchSavePositionChange(details);
      } else {
        const details = this.details.map((item) => ({
          productPositionId: item.productPositionId,
          applyPositionCode: item.applyPositionCode,
          applyPositionName: item.selectableInstallPositions.find(
            (ele) => ele.installPositionCode == item.applyPositionCode
          )?.installPositionName,
        }));
        this.savePositionChange(details);
      }
    },
  },
  created() {},
};
</script>
<style lang="scss" scoped>
/deep/.report-dialog {
  .el-dialog__body {
    padding: 0px 10px 10px;
    .content {
      margin-top: 15px;
      .el-form-item {
        margin-bottom: 10px;
      }
    }
    .img-demo {
      display: flex;
      margin-top: 40px;
      .e6-image {
        margin-right: 20px;
      }
    }
  }
}
.title {
  margin: 10px 15px;
  display: flex;
  align-items: center;
  .line {
    display: inline-block;
    width: 3px;
    height: 15px;
    margin-right: 5px;
    background-color: #46bfea;
  }
}
.dialog-content {
  padding: 20px;
}
.el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0px;
}
</style>
